/*global __TABLEAU_API__ */

import sa from 'superagent';

class MyAPI {
  constructor(api) {
    this.api = api;
  }

  workbooks(orgId) {
    return this.api.get(`/my/workbooks/${orgId}`)
      .then(data => data.body.workbooks);
  }

  ticket(orgId) {
    return this.api.get(`/my/trustedurl/${orgId}`)
      .then(data => data.body.trustedurl);
  }

}

class API {
  constructor(token) {
    this.token = token;
    this.my = new MyAPI(this);
  }

  get(url) {
    return sa.get(`${__TABLEAU_API__}${url}`).set('Authorization', `Bearer ${this.token}`);
  }

  post(url) {
    return sa.post(`${__TABLEAU_API__}${url}`).set('Authorization', `Bearer ${this.token}`);
  }

  put(url) {
    return sa.put(`${__TABLEAU_API__}${url}`).set('Authorization', `Bearer ${this.token}`);
  }

}

export default API;
